import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  NgxAimAdminRoutes,
  NgxAimAdminDashboardComponent,
  NgxAimAdminUsersComponent,
  NgxAimAdminWebCategoriesComponent,
  NgxAimAdminCategoriesComponent,
  NgxAimAdminContractsComponent,
  NgxAimAdminOrdersComponent,
  NgxAimAdminCustomerDefaultsComponent,
  NgxAimAdminTaxAuthorityComponent,
  NgxAimAdminLocationsComponent,
  NgxAimAdminItemsComponent,
  NgxAimAdminCarouselComponent,
  NgxAimAdminGlobalpayComponent,
  NgxAimAdminCountryStatesComponent,
  NgxAimAdminCarriersServicesComponent,
  NgxAimAdminFflComponent,
  NgxAimAdminContractFormInputComponent,
  NgxAimAdminTsysComponent,
  NgxAimAdminAppPostsComponent,
  NgxAimAdminEditAppPostComponent,
  NgxAimAdminStrTimeSlotsComponent,
} from 'ngx-aim';
import { AdminLayoutComponent } from './admin-layout/admin-layout.component';

const routes: Routes = [
  {
    path: '',
    component: AdminLayoutComponent,
    children: [
      {
        path: '', title: 'Dashboard', component: NgxAimAdminDashboardComponent
      },
      {
        path: NgxAimAdminRoutes.USERS, title: 'Users', component: NgxAimAdminUsersComponent
      },
      {
        path: NgxAimAdminRoutes.WEB_CATEGORIES, title: 'Web Categories', component: NgxAimAdminWebCategoriesComponent
      },
      {
        path: NgxAimAdminRoutes.CATEGORIES, title: 'Categories', component: NgxAimAdminCategoriesComponent
      },
      {
        path: NgxAimAdminRoutes.CONTRACTS, title: 'Contracts', component: NgxAimAdminContractsComponent
      },
      {
        path: NgxAimAdminRoutes.ORDERS, title: 'Orders', component: NgxAimAdminOrdersComponent
      },
      {
        path: NgxAimAdminRoutes.CUSTOMER_DEFAULTS, title: 'Customer Defaults', component: NgxAimAdminCustomerDefaultsComponent
      },
      {
        path: NgxAimAdminRoutes.TAX_AUTHORITY, title: 'Tax Authority', component: NgxAimAdminTaxAuthorityComponent
      },
      {
        path: NgxAimAdminRoutes.LOCATIONS, title: 'Locations', component: NgxAimAdminLocationsComponent
      },
      {
        path: NgxAimAdminRoutes.ITEMS, title: 'Items', component: NgxAimAdminItemsComponent
      },
      {
        path: NgxAimAdminRoutes.CAROUSEL, title: 'Carousel', component: NgxAimAdminCarouselComponent
      },
      {
        path: NgxAimAdminRoutes.GLOBAL_PAY, title: 'Global Pay', component: NgxAimAdminGlobalpayComponent
      },
      {
        path: NgxAimAdminRoutes.STATES, title: 'States', component: NgxAimAdminCountryStatesComponent
      },
      {
        path: NgxAimAdminRoutes.SHIPPING, title: 'Shipping', component: NgxAimAdminCarriersServicesComponent
      },
      {
        path: NgxAimAdminRoutes.FFLS, title: 'FFL', component: NgxAimAdminFflComponent
      },
      {
        path: `${NgxAimAdminRoutes.CONTRACTS}/${NgxAimAdminRoutes.FORM_IMPUTS}`, title: 'Contract Form Inputs', component: NgxAimAdminContractFormInputComponent
      },
      {
        path: NgxAimAdminRoutes.TSYS, title: 'Tsys', component: NgxAimAdminTsysComponent
      },
      {
        path: NgxAimAdminRoutes.APP_POSTS, title: 'Posts', component: NgxAimAdminAppPostsComponent
      },
      {
        path: `${NgxAimAdminRoutes.APP_POSTS}/${NgxAimAdminRoutes.EDIT}/:id`, title: 'Edit Post', component: NgxAimAdminEditAppPostComponent
      },
      {
        path: NgxAimAdminRoutes.STR_TIME_SLOTS, title: 'Short Term Rental Time Slots', component: NgxAimAdminStrTimeSlotsComponent,
      },
    ]
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule {}
